<template>
  <div>
    <CDEKHead
        :countFilterParams="countFilterParams"
        :showFilter="showFilter"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">

      <CDEKFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          @close="closeFilter"
          @changeFilter="data => $emit('changeFilter', data)"
          @resetFilter="$emit('resetFilter')"
      />

      <CDEKTable
          :countFilterParams="countFilterParams"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @updateTable="$emit('updateTable')"
          @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import CDEKHead from "./CDEKHead/CDEKHead";
  import CDEKFilter from "./CDEKFilter/CDEKFilter";
  import CDEKTable from "./CDEKTable/CDEKTable";

  export default {
    name: "CDEKTableUser",

    components: {
      CDEKHead,
      CDEKFilter,
      CDEKTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    methods: {
      // closeFilter() {
      //   this.showFilter = false
      // },
      //
      // toggleFilter() {
      //   this.showFilter = !this.showFilter
      // },
      //
      // changeShopType(index) {
      //   this.$emit('changeShopType', index)
      // },
      //
      //
      // changeFilter(data) {
      //   this.$emit('changeFilter', data)
      // },
      //
      // changeTab(id) {
      //   this.activeTab = id
      // },

      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
